import { render, staticRenderFns } from "./LogoBlackAndWhiteSection.vue?vue&type=template&id=10945215"
import script from "./LogoBlackAndWhiteSection.vue?vue&type=script&lang=ts"
export * from "./LogoBlackAndWhiteSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoBlackAndWhiteSection.vue?vue&type=style&index=0&id=10945215&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports